import React from 'react';
import { TOP_LEVEL_SERVICE_PAGE } from 'constants/Services';
import { TopLevelServicePage } from 'views/Services';
import configureStore from 'state/configureStore';

import getInitialPropsForServicePage from 'helpers/services/getServiceProps';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

export const MusicalEntertainment = (props) => <TopLevelServicePage {...props} />;

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const { res, req } = ctx;
      return await getInitialPropsForServicePage(
        res,
        store,
        { serviceSlug: 'musical-entertainment' },
        TOP_LEVEL_SERVICE_PAGE,
        req
      );
    })
);

export default MusicalEntertainment;
